import React, { useState } from "react";
import {
  Input,
  Select,
  Textarea,
  FormField,
  Button,
  SectionTitle,
} from "../../../SharedInputs.jsx";
import { Calendar } from "lucide-react";
import { updateStudentFollowUps } from "../../../../services/StudentRecordService.js";

const FOLLOWUP_TYPES = [
  "Fee Plan Follow-up",
  "Reminder 1",
  "Reminder 2",
  "Reminder 3",
  "Warning Letter 1",
  "Warning Letter 2",
  "Warning Letter 3",
  "Final Cancelation Call",
  "Final Cancelation Message",
  "Final Cancelation",
];

export const SectionFollowUps = ({ onCancel, initialData = {} }) => {
  const [expandedIdx, setExpandedIdx] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [followUps, setFollowUps] = useState(initialData.followUps || []);
  const [loading, setLoading] = useState(false);
  const COURSES = initialData?.formState?.courses || [];
  const [feeInstallments, setFeeInstallments] = useState([]);

  const handleCourseChange = (courseId) => setSelectedCourseId(courseId);

  const handleFollowUpChange = (idx, field, value) => {
    const updated = [...followUps];
    updated[idx] = { ...updated[idx], [field]: value };
    setFollowUps(updated);
  };
  const handleFollowUpChangeCourse = (idx, field, value, course) => {
    setFeeInstallments(course?.feesPlan?.installments || [])
    const updated = [...followUps];
    updated[idx] = { ...updated[idx], [field]: value };
    setFollowUps(updated);
  };

  const addFollowUp = () => {
    const today = new Date().toISOString().split("T")[0];
    const newFollowUp = {
      notes: "",
      date: today,
      type: "",
      customType: "",
      installment: "",
      customInstallment: "",
      courseName: "",
      doneBy: "",
    };
    setFollowUps([...followUps, newFollowUp]);
    setExpandedIdx(followUps.length);
  };

  const removeFollowUp = async (idx) => {
    try {
      const updated = [...followUps];
      updated.splice(idx, 1);
      setFollowUps(updated);
      if (expandedIdx === idx) setExpandedIdx(null);

      if (initialData?.id) {
        await updateStudentFollowUps(
          initialData.id,
          initialData.formState,
          initialData.enrolmentReferenceId,
          updated
        );
        initialData.followUps = updated;
        alert("Follow-up removed successfully!");
      }
    } catch (error) {
      alert("Failed to remove follow-up. Please try again.");
      console.error(error);
    }
  };

  const saveFollowUp = async (idx) => {
    setLoading(true);
    try {
      const updated = [...followUps];
      const courseObj = COURSES.find(
        (c) => c.courseName === updated[idx].courseName
      );
      updated[idx].courseName = courseObj ? courseObj.courseName : "";
      setFollowUps(updated);

      initialData.followUps = updated;
      if (initialData?.id) {
        await updateStudentFollowUps(
          initialData.id,
          initialData.formState,
          initialData.enrolmentReferenceId,
          updated
        );
      }
      alert("Student record saved successfully!");
    } catch (error) {
      alert("Failed to save student record. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <SectionTitle icon={Calendar}>Follow-ups & Tracking</SectionTitle>
        <Button size="sm" onClick={addFollowUp}>
          + Add Follow-up
        </Button>
      </div>
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            borderRadius: "12px"
          }}
        >
          <div className="spinner" style={{ textAlign: "center" }}>
            <div className="loader" style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 12px",
              
            }} />
            
          </div>
          <p style={ {
            padding: "0.5rem",
          }
          }>Saving, please wait!</p>
        </div>
      )}

      {followUps.map((fu, idx) => (
        <div
          key={idx}
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            marginBottom: 12,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: 12,
              cursor: "pointer",
              background: "#f9fafb",
              alignItems: "center",
            }}
            onClick={() => setExpandedIdx(expandedIdx === idx ? null : idx)}
          >
            <div>{`Follow-up #${idx + 1}`}</div>
            <div>Date: {fu.date || "-"}</div>
            <div>
              Type:{" "}
              {fu.type === "Other" && fu.customType
                ? ` (${fu.customType})`
                : fu.type || "-"}
            </div>
            <div>Course: {fu.courseName || "-"}</div>
            <div>
              Installment:{" "}
              {fu.installment === "Other" && fu.customInstallment
                ? ` (${fu.customInstallment})`
                : fu.installment || "-"}
            </div>
            <div>{expandedIdx === idx ? "▲" : "▼"}</div>
          </div>

          {/* Expanded Body */}
          {expandedIdx === idx && (
            <div style={{ padding: 12, background: "#fff", width: "100%" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 12,
                }}
              >
                <FormField label="Date">
                  <Input
                    type="date"
                    value={fu.date}
                    onChange={(e) =>
                      handleFollowUpChange(idx, "date", e.target.value)
                    }
                  />
                </FormField>

                <FormField label="Select Course">
                  <Select
                    value={fu.courseName || ""}
                    onChange={(e) => {
                      
                      const courseObj = COURSES.find(
                        (c) => c.courseName === e.target.value
                      );
                      handleCourseChange(courseObj.courseName);
                      handleFollowUpChangeCourse(
                        idx,
                        "courseName",
                        courseObj?.courseName || "",
                        courseObj
                      );
                    }}
                  >
                    <option value="">Select Course</option>
                    {COURSES.map((course, i) => (
                      <option key={i} value={course.courseName}>
                        {course.courseName}
                      </option>
                    ))}
                  </Select>
                </FormField>

                <FormField label="Type">
                  <Select
                    value={fu.type}
                    onChange={(e) =>
                      handleFollowUpChange(idx, "type", e.target.value)
                    }
                  >
                    <option value="">Select Type</option>
                    {FOLLOWUP_TYPES.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                    <option value="Other">Other</option>
                  </Select>
                  {fu.type === "Other" && (
                    <Input
                      type="text"
                      placeholder="Custom Type"
                      value={fu.customType || ""}
                      onChange={(e) =>
                        handleFollowUpChange(idx, "customType", e.target.value)
                      }
                    />
                  )}
                </FormField>

                <FormField label="Installment">
                  <Select
                    value={fu.installment}
                    onChange={(e) =>
                      handleFollowUpChange(idx, "installment", e.target.value)
                    }
                  >
                    <option value="">Select Installment</option>
                    {feeInstallments.map((inst, i) => (
                      <option key={i} value={`Installment #${i + 1}`}>
                        {`Installment #${i + 1}`}
                      </option>
                    ))}
                    <option value="Other">Other</option>
                  </Select>
                  {fu.installment === "Other" && (
                    <Input
                      type="text"
                      placeholder="Custom Installment"
                      value={fu.customInstallment || ""}
                      onChange={(e) =>
                        handleFollowUpChange(
                          idx,
                          "customInstallment",
                          e.target.value
                        )
                      }
                    />
                  )}
                </FormField>
                <FormField label="Follow-up Done By">
                  <Input
                    type="text"
                    placeholder="Enter name"
                    value={fu.doneBy || ""}
                    onChange={(e) =>
                      handleFollowUpChange(idx, "doneBy", e.target.value)
                    }
                  />
                </FormField>
              </div>

              <FormField label="Notes">
                <Textarea
                  value={fu.notes}
                  onChange={(e) =>
                    handleFollowUpChange(idx, "notes", e.target.value)
                  }
                />
              </FormField>

              <div
                style={{
                  marginTop: 8,
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 8,
                }}
              >
                <Button variant="secondary" onClick={() => saveFollowUp(idx)}>
                  Save
                </Button>
                <Button variant="destructive" onClick={() => removeFollowUp(idx)}>
                  Remove
                </Button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
